import * as actions from './create-user.actions'
import { GetCompaniesResult, GetRightsResult } from 'src/services/ds.service'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'
import { UserIdentity } from 'src/users-components/login/login.reducer'

export interface CreateUserState {
  identity: Option<UserIdentity>
  rights: Option<GetRightsResult>
  companies: Option<GetCompaniesResult>
}

export const identityLense = Lens.fromProp<CreateUserState>()('identity')
export const rightsLense = Lens.fromProp<CreateUserState>()('rights')
export const companiesLense = Lens.fromProp<CreateUserState>()('companies')

export const initialCreateUserState: CreateUserState = {
  identity: none,
  rights: none,
  companies: none
}

export const sameState: (s: CreateUserState) => CreateUserState = identity

export const createUserReducer: Reducer<actions.CreateUserActions, CreateUserState> = actions.createUserActions.match({
  CreateUser: _action => sameState,
  CreateUserSuccess: _action => sameState,
  CreateUserFailure: _action => sameState,
  LoadRightsSuccess: action => rightsLense.set(some(action.rights)),
  LoadRightsFailed: _action => rightsLense.set(none),
  LoadCompaniesSuccess: action => companiesLense.set(some(action.companies)),
  LoadCompaniesFailed: _action => companiesLense.set(none),
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/users-components/create-user/create-user.reducer.ts